/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-04-30T20:46:15.525Z
 */

declare const __SSR_REGION__: string | undefined;

// prettier-ignore
const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 25
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 26
	'FollowingFeedWithSortByStorageSnippetsQuery', // 27
	'FooterCreateButtonsQuery', // 28
	'ForgeExtensionList', // 29
	'GlobalNavigationComponentQuery', // 30
	'GrantAccessDialogLoaderQuery', // 31
	'HomeRecentWorkQuery', // 32
	'InlineCommentsFocusedInlineCommentQuery', // 33
	'LegacyMacroRendererQueryBodyQuery', // 34
	'LivePagesByLineLastUpdatedQuery', // 35
	'LocalStorageQuery', // 36
	'NativeCollabQuery', // 37
	'NotFoundContainerQuery', // 38
	'NotificationsButtonQuery', // 39
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 40
	'PageRestrictionsContextQuery', // 41
	'PageTreeQuery', // 42
	'PageTreeQueryWithSpaceKeyQuery', // 43
	'PermissionCheckAddCommentQuery', // 44
	'PersistentInviteEligibleQuery', // 45
	'PersonalizedTemplatesV2AllTemplatesQuery', // 46
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 47
	'Preferences', // 48
	'PremiumTrialEotQuery', // 49
	'ReactionsContentQuery', // 50
	'RecentlyUpdatedMacroQuery', // 51
	'RendererContentStateQuery', // 52
	'RestrictedPageWithCanViewQuery', // 53
	'ScreenQuery', // 54
	'SiteInformationQuery', // 55
	'SmartCreateFeedbackBannerQuery', // 56
	'SmartCreatePageEditorDataWrapperComponentQuery', // 57
	'SpaceNavigationQuery', // 58
	'SpaceOverviewIdQuery', // 59
	'SpaceOverviewQuery', // 60
	'SpaceQuery', // 61
	'SpaceRestrictionCheckQuery', // 62
	'ThemeQuery', // 63
	'TopNavigationQuery', // 64
	'UserSettingsQuery', // 65
	'ViewSpaceExternalCollaboratorsDialogQuery', // 66
	'WebItemLocationQuery_page.metadata.banner', // 67
	'WebItemLocationQuery_system.content.byline', // 68
	'WebItemLocationQuery_system.header_left', // 69
	'WebItemLocationQuery_system.header_left_system.user', // 70
	'WebPanelLocationQuery_atl.footer', // 71
	'WebPanelLocationQuery_atl.general', // 72
	'WebPanelLocationQuery_atl.general_atl.footer', // 73
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 74
	'WebStorageCategories', // 75
	'WelcomeMessagesQuery', // 76
	'WhiteboardUnifiedQuery', // 77
	'contentAppearanceQuery', // 78
	'contentSmartLinksORS', // 79
	'fetchMentionsProviderDataQuery', // 80
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 81
	'graphqlHelpersFetchMediaTokenQuery', // 82
	'multiMacroQueryQuery', // 83
	'multiMacroQueryWithAppKeyQuery', // 84
	'onboardingStateGetOnboardingStateQuery', // 85
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 86
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 87
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 88
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 89
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 90
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 91
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages', // 92
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 93
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 94
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 95
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_22', // 96
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_67', // 97
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 100
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 101
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserGSPagePath_6', // 102
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 103
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_150', // 104
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_151', // 105
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 106
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_156', // 107
	'pageButtons', // 108
	'preloadAutohighlightsQuery', // 109
	'preloadContentSmartLinksQuery', // 110
	'preloadCreateSpaceQuery', // 111
	'preloadEditButtonWithSpaceKeyQuery', // 112
	'preloadEditorNodeDataProvidersDataQuery', // 113
	'preloadLegacyBridgeQuery', // 114
	'preloadOperationsQuery', // 115
	'preloadPageStatusQueryDataQuery', // 116
	'preloadPersonalSpaceDetailsQuery', // 117
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 118
	'preloadSpaceBlogCountQuery', // 119
	'preloadTemplatesCollectionEligibleQuery', // 120
	'requireSuperBatchFrontendResourceRenderQuery', // 121
	'rightPanel', // 122
	'searchCombinedConfig', // 123
	'searchResults', // 124
	'sidenavSmartLinksORS', // 125
	'useAnalyticsByLineQuery', // 126
	'useAudioContentQuery', // 127
	'useBlogPostsQueryQuery', // 128
	'useConfluenceStandardToPremiumExperimentQuery', // 129
	'useContentClassificationContentDataClassificationQuery', // 130
	'useContributorsDataQuery', // 131
	'useEditorContentModeValueQuery', // 132
	'useEmojiEverSetPropertyQuery', // 133
	'useFabricEligibilityMigrationQuery', // 134
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 135
	'useFeedTypeSelectorRefreshQuery', // 136
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 137
	'useGetCurrentStorageUsageQuery', // 138
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 139
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 140
	'useHomeWidgetStateQuery', // 141
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 142
	'useIsLoomEntryPointsEnabledQuery', // 143
	'useIsUserViewingSpaceAsAnonQuery', // 144
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 145
	'useLoomTenantProvisionStatusQuery', // 146
	'usePopularFeedWithTimeGranularityStorageQuery', // 147
	'usePreloadCommentButtonQuery', // 148
	'useReadTimeQuery', // 149
	'useRegisterAdminAnnouncementBannerQuery', // 150
	'useShareAndRestrictButtonDataQuery', // 151
	'useShortcutsSpaceNavigationQuery', // 152
	'useSpaceBaseQueryBaseQuery', // 153
	'useSpaceDetailQuery', // 154
	'useSpaceEnabledContentTypesQuery', // 155
	'useSpaceViewsDataSpaceRootQuery', // 156
	'useSpaceViewsOptionsPersistenceQuery', // 157
	'useSpacesDataAnonymousSpacesQuery', // 158
	'useSpacesDataMyVisitedSpacesQuery', // 159
	'useSpacesDataStarredSpacesQuery', // 160
	'useTitleContentPropertiesForEditorQuery', // 161
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 162
	'useTitleContentPropertiesForPublishedPageQuery', // 163
	'useUserByLicensedProductsQuery', // 164
];

// prettier-ignore
const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7b77fb5ef3ffff65f76dfefdffd6f6bdf73f0f', /* 131 fast, 20 slow, 69 excl */
	'prod-apne2': 'b5ff7bf7fa5ef3ffff6df76ddeffdfd4f6bdf73f0f', /* 130 fast, 22 slow, 125 excl */
	'prod-apse': 'ddff7bf7fb5ef7ffff6df7edfeffffd6f6bdf77f0f', /* 138 fast, 17 slow, 115 excl */
	'prod-apse2': 'fdff7bf7fa5ef7ffff7df7edffffffd7f6b9f7ff1f', /* 142 fast, 14 slow, 83 excl */
	'prod-apsouth': 'd5fffb77fe5ef3ffff75f7edffffffd5d6bdf7bf1f', /* 137 fast, 13 slow, 14 excl */
	'prod-cacentral': 'fdff7b77ff7ef7ffff7df7edffffffd5f6fdf7bf1f', /* 144 fast, 8 slow, 9 excl */
	'prod-east': 'fdff7ff7fb7ef7ffff7df7edffffffd7f6fdf7ff1f', /* 147 fast, 10 slow, 165 excl */
	'prod-eucentral': 'ffff7ff7fb5ef7ffff6df7edfeffff97f6bdf77f0f', /* 141 fast, 17 slow, 181 excl */
	'prod-eucentral2': 'fddf7b37fa5ef7fdff6de76dfeffff81f69df7bf0f', /* 128 fast, 23 slow, 7 excl */
	'prod-euwest': 'ffff7ff7fb7ef7ffff7df7edffffff97f6fdf77f1f', /* 146 fast, 12 slow, 182 excl */
	'prod-euwest2': 'fdff7bf7fb7ef7ffff7df7edffffffd5f6fdf7bf1f', /* 144 fast, 9 slow, 82 excl */
	'prod-west2': '9dff7ff7fb7ef7ffff7df7edffffffd7f6fdf7ff1f', /* 145 fast, 11 slow, 170 excl */
	'stg-east': '76f3fb57fc7fd5ddff5ffffbbde47fa1f6fbffbf1f', /* 129 fast, 15 slow, 55 excl */
	'stg-local': '000000000000000000000000000000000000000000', /* 0 fast, 0 slow, 72 excl */
	'stg-west2': '000000000000000000000000000000000000000000', /* 0 fast, 0 slow, 70 excl */
};

const _cache = new Map<string, ReadonlySet<string>>();

function _decode(region: string): ReadonlySet<string> {
	const cached = _cache.get(region);
	if (cached) return cached;
	const hex = R[region];
	if (!hex) return _empty;
	const set = new Set<string>();
	for (let i = 0; i < Q.length; i++) {
		// eslint-disable-next-line no-bitwise
		const byteIdx = i >> 3;
		// eslint-disable-next-line no-bitwise
		const bitIdx = i & 7;
		const byte = parseInt(hex.slice(byteIdx * 2, byteIdx * 2 + 2), 16);
		// eslint-disable-next-line no-bitwise
		if (byte & (1 << bitIdx)) set.add(Q[i]);
	}
	const frozen = Object.freeze(set) as ReadonlySet<string>;
	_cache.set(region, frozen);
	return frozen;
}

const _empty: ReadonlySet<string> = Object.freeze(new Set<string>());
const _aggPrefix = 'agg_';

function _getEquivalentQueryName(queryName: string): string {
	return queryName.startsWith(_aggPrefix)
		? queryName.slice(_aggPrefix.length)
		: `${_aggPrefix}${queryName}`;
}

/**
 * Check whether a preload query is classified as fast (batchable) for the
 * current SSR region.
 *
 * @param queryName — the GraphQL operation name.
 * @param region — SSR region override; defaults to window.__SSR_REGION__.
 */
export function isFastPreloadQuery(
	queryName: string,
	region: string = typeof __SSR_REGION__ !== 'undefined' ? __SSR_REGION__ : '',
): boolean {
	const fastQueries = _decode(region);
	return fastQueries.has(queryName) || fastQueries.has(_getEquivalentQueryName(queryName));
}
